import UserFilterEnum from '../types/user/UserFilterEnum';
import { UserFilterOptions } from '../types/user/UserFilterOptions';
import UserFilter from '../types/user/UserFilters';

export type OptionType = {
    id: string;
    value: number | string;
};

class OptionsMapper {
    public static [UserFilterEnum.Department](options: UserFilterOptions): OptionType[] {
        const departments = options[UserFilterEnum.Department];

        return departments.map((department) => ({
            id: department.departmentId.toString(),
            value: department.departmentName,
        }));
    }

    public static [UserFilterEnum.Company](options: UserFilterOptions): OptionType[] {
        const businessUnits = options[UserFilterEnum.Company];

        return businessUnits.map((businessUnit) => ({
            id: businessUnit.id.toString(),
            value: businessUnit.description,
        }));
    }

    public static [UserFilterEnum.Location](options: UserFilterOptions): OptionType[] {
        const locations = options[UserFilterEnum.Location];

        return locations.map((location) => ({ id: location.locationId.toString(), value: location.locationName }));
    }

    public static [UserFilterEnum.DateInService](options: UserFilterOptions): OptionType[] {
        const inDates = options[UserFilterEnum.DateInService];

        return inDates.map((inDate) => ({
            id: `${inDate.year}-${inDate.month} (${inDate.count})`,
            value: `${inDate.year}-${inDate.month} (${inDate.count})`,
        }));
    }
}

export class OptionsHelper {
    public static [UserFilterEnum.Department](filters: UserFilter, id: string): UserFilter {
        const selected = filters.Values.includes(+id);
        const Values = [...filters.Values];

        if (selected) {
            const indexOfValue = filters.Values.findIndex((value) => value === +id);
            Values.splice(indexOfValue, 1);
        } else {
            Values.push(+id);
        }

        return { ...filters, Values };
    }

    public static [UserFilterEnum.Company](filters: UserFilter, id: string): UserFilter {
        const selected = filters.Values.includes(+id);
        const Values = [...filters.Values];

        if (selected) {
            const indexOfValue = filters.Values.findIndex((value) => value === +id);
            Values.splice(indexOfValue, 1);
        } else {
            Values.push(+id);
        }

        return { ...filters, Values };
    }

    public static [UserFilterEnum.Location](filters: UserFilter, id: string): UserFilter {
        const selected = filters.Values.includes(+id);
        const Values = [...filters.Values];

        if (selected) {
            const indexOfValue = filters.Values.findIndex((value) => value === +id);
            Values.splice(indexOfValue, 1);
        } else {
            Values.push(+id);
        }

        return { ...filters, Values };
    }

    public static [UserFilterEnum.DateInService](filters: UserFilter, id: string): UserFilter {
        const newValue: string = id.replace('-', ' ').replace('(', '').replace(')', '');
        const [yearValue, monthValue] = newValue.split(' ');
        const Year = [...filters.Year];
        const Month = [...filters.Month];

        const indexOfValue = filters.Month.findIndex(
            (month, index) => month === monthValue && filters.Year[index] === yearValue,
        );

        if (indexOfValue > -1) {
            Year.splice(indexOfValue, 1);
            Month.splice(indexOfValue, 1);
        } else {
            Year.push(yearValue);
            Month.push(monthValue);
        }

        return { ...filters, Year, Month };
    }
}

export default OptionsMapper;
